export type TariffPeriodDays = '7' | '30' | '180' | '365';

export type TariffItem = {
  id: string;
  price: number;
  price_of: number;
};

export type TariffPlanPeriods = Partial<Record<TariffPeriodDays, TariffItem>>;

export type Tariffs = Record<string, TariffPlanPeriods>;

export type PricingAddonName =
  | 'tracker'
  | 'trcaker'
  | 'mentoring_seo'
  | 'mentoring_seo_360'
  | 'wallet'
  | (string & {});

export type PricingAddon = {
  id: string;
  name: PricingAddonName;
  price: number;
};

export type RealAndLegal = {
  name: string;
  economical_number: string;
  registration_code: string;
  national_id: string;
  city: string;
  province: string;
  postal_code: string;
  address: string;
  phone_number: string;
  status: number;
  rejection_reason: string | null;
};

export type GetTariffsData = {
  tariffs: Tariffs;
  addons: PricingAddon[];
  real_and_legal: RealAndLegal | null;
  remaining_amount?: number;
};

export type GetTariffsResponse = {
  data: GetTariffsData;
  success: boolean;
  code: number;
  validationErrors: unknown | null;
  msg: string | null;
};

export type CreateOrderTrackerAddon = {
  keywords: number;
  weekly_updates: number;
  depth: number;
};

export type CreateOrderWalletAddon = {
  amount: number;
};

export type CreateOrderAddons = Record<
  string,
  CreateOrderTrackerAddon | CreateOrderWalletAddon | null
>;

export type CreateOrderRequest = {
  tariff_price_id: string;
  addons: CreateOrderAddons;
  introduced_code?: string | null;
  use_wallet: boolean;
  re_payment?: boolean;
};

export type CreateOrderData = {
  order_id: string;
  need_to_pay: boolean;
  price: number;
  redirect_url: string;
};

export const ANNUAL_PLAN_BLOCKS_MONTHLY_CODE = 60004;

export type CreateOrderResponse = {
  data: CreateOrderData;
  success: boolean;
  code: number;
  validationErrors: unknown | null;
  msg: string | null;
};
